import { BListGroupItem } from 'bootstrap-vue'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    screenWidth: document.body.clientWidth,
    bigTitle: '',
    footTxt:'',
    chType:'',
    chChildrenType:'',
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
